import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ style = {} }) => {
  const { language, changeLanguage, t } = useTranslation();

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    ...style
  };

  const buttonStyle = {
    background: language === 'fr' ? 'rgba(0, 212, 255, 0.3)' : 'transparent',
    color: language === 'fr' ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
    border: language === 'fr' ? '1px solid rgba(0, 212, 255, 0.5)' : '1px solid rgba(255, 255, 255, 0.2)',
    padding: '6px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: language === 'fr' ? '600' : '500',
    transition: 'all 0.2s',
    backdropFilter: 'blur(10px)',
    ...(language === 'fr' && {
      boxShadow: '0 2px 8px rgba(0, 212, 255, 0.3)'
    })
  };

  const buttonEnStyle = {
    ...buttonStyle,
    background: language === 'en' ? 'rgba(0, 212, 255, 0.3)' : 'transparent',
    color: language === 'en' ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
    border: language === 'en' ? '1px solid rgba(0, 212, 255, 0.5)' : '1px solid rgba(255, 255, 255, 0.2)',
    fontWeight: language === 'en' ? '600' : '500',
    ...(language === 'en' && {
      boxShadow: '0 2px 8px rgba(0, 212, 255, 0.3)'
    })
  };

  return (
    <div style={containerStyle}>
      <Globe size={18} style={{ color: 'rgba(255, 255, 255, 0.7)' }} />
      <button
        onClick={() => changeLanguage('fr')}
        style={buttonStyle}
        title="Français"
        onMouseEnter={(e) => {
          if (language !== 'fr') {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          }
        }}
        onMouseLeave={(e) => {
          if (language !== 'fr') {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
          }
        }}
      >
        FR
      </button>
      <button
        onClick={() => changeLanguage('en')}
        style={buttonEnStyle}
        title="English"
        onMouseEnter={(e) => {
          if (language !== 'en') {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          }
        }}
        onMouseLeave={(e) => {
          if (language !== 'en') {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
          }
        }}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSelector;

